import React, { useEffect, useState } from 'react';
import axios from 'axios';
import ProductList from '../../components/DynamicListGrid/DynamicListGrid';
import {getStoredData} from "../../JsonFiles/fetchData";
import { useNavigate } from 'react-router-dom';

const AdminSubmission = () => {
  const [products, setProducts] = useState([]);
  const [loading, setLoading] = useState(true);
  const navigate = useNavigate();
  const totalData = getStoredData();
  const fields = totalData ? totalData["11"].AdminSubmission : {};

  useEffect(() => {
    const fetchProducts = async () => {
      try {
        const response = await axios.get('https://shahbad-enterprises-backend.vercel.app/form');
        setProducts(response.data);
        setLoading(false);
      } catch (error) {
        console.error('Error fetching products:', error);
        setLoading(false);
      }
    };

    fetchProducts();
  }, []);

  if (loading) {
    return <p>Loading Submission...</p>;
  }

  return (
    <div className="admin-products">
      <h2>Form List</h2>
      <ProductList products={products} fields={fields} redirect={totalData[12].AdminProjectsEdit} deleteApi="https://shahbad-enterprises-backend.vercel.app/form"/>
    </div>
  );
};

export default AdminSubmission;
